export class RemoteServerError {
    message?: string;
    response?: Response;

    constructor(message?: string, response?: Response) {
        this.message = message;
        this.response = response;
    }
}
